import { ApplicationInsights, IExtendedConfiguration } from "@microsoft/1ds-analytics-web-js";
import { CorrelationVectorPlugin } from "@microsoft/1ds-cv-js";
import { IUCISModel } from "./Interfaces/interface";

// CommonSchema UTC flag that tells the Aria collector to scrub ext.ingest.clientIp.
const SCRUB_IP_FLAG = 0x100000; // 1048576 decimal

// Pipeline plugin: stamps the ScrubIp flag on every event before it reaches the
// PostChannel. Unlike addTelemetryInitializer(), pipeline plugins are wired into
// the chain BEFORE any plugin's initialize() runs, so auto-captured events
// (pageView, onLoad) that fire during initialize() are also covered (ICM 759298390).
const scrubIpPlugin: any = {
    identifier: "ScrubIpPlugin",
    // tslint:disable-next-line:no-shadowed-variable
    initialize: (cfg: any, core: any, ext: any) => { /* no-op */ },
    isInitialized: () => true,
    priority: 190,
    processTelemetry: (item: any, itemCtx: any) => {
        item.ext = item.ext || {};
        item.ext.utc = item.ext.utc || {};
        // tslint:disable-next-line:no-bitwise
        item.ext.utc.eventFlags = (item.ext.utc.eventFlags || 0) | SCRUB_IP_FLAG;

        if (itemCtx) {
            itemCtx.processNext(item);
        }
    }
};


const analytics: ApplicationInsights = new ApplicationInsights();
let cvPlugin: CorrelationVectorPlugin = new CorrelationVectorPlugin();
const ucisData: IUCISModel = window.ucis;
let config: IExtendedConfiguration = {
    channelConfiguration: { // Post channel configuration
        eventsLimitInMem: 50
    },
    extensions: [
        cvPlugin,
        scrubIpPlugin
    ],
    instrumentationKey: ucisData?.OneDsToken,
    propertyConfiguration: { // Properties Plugin configuration
        // populateBrowserInfo: true,
        populateOperatingSystemInfo: true,
        userAgent: window.navigator.userAgent,
    },
    webAnalyticsConfiguration: { // Web Analytics Plugin configuration
        autoCapture: {
            click: true,
            jsError: true,
            onLoad: true,
            onUnload: true,
            pageView: true,
            resize: true,
            scroll: true
        }
    }
};

//Initialize SDK
analytics.initialize(config, []);

// Set CommonSchema ScrubIp flag (0x100000) on every event so the Aria collector
// scrubs ext.ingest.clientIp before persisting to Geneva (ICM 759298390)
analytics.addTelemetryInitializer((item) => {
    item.ext = item.ext || {};
    item.ext.utc = item.ext.utc || {};
    (item.ext.utc as any).eventFlags = 1048576;
});

export default analytics;
